export enum RequestState {
	IDLE = "idle",
	Requested = "requested",
	Received = "received",
	Error = "error",
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
}

export enum PositionType {
	Catcher = "catcher",
	Empty = "",
	FirstBase = "first_base",
	Outfielder = "outfielder",
	Pitcher = "pitcher",
	SecondBase = "second_base",
	Shortstop = "shortstop",
	ThirdBase = "third_base",
}

export enum StatusType {
	Active = "active",
	InActive = "inactive",
}

export enum PoolTabsType {
	Popular = "popular",
	Suggested = "suggested",
	Club = "by_club",
	Favorite = "favorite",
}

export enum LeaderboardsTabsType {
	Yesterday = "YESTERDAY",
	ActiveStreak = "ACTIVE_STREAK",
	AllSeason = "SEASON_BEST_STREAK",
	AllTime = "OVERALL_BEST_STREAK",
}

export enum LeaderboardUsersType {
	All = "ALL",
	Friends = "FRIENDS",
}
export enum PredictionResult {
	Hit = "hit",
	NotHit = "not_hit",
	Void = "void",
	UsedMulligan = "used_mulligan",
}

export enum UnitStatusType {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
	Postponed = "postponed",
	Canceled = "canceled",
}

export enum TvNetwork {
	MLBTV = "MLBTV",
	YouTube = "YOUTUBE",
	Fox = "FOX",
	ESPN = "ESPN",
	TBS = "TBS",
	MLBN = "MLBN",
	ESPN2 = "ESPN2",
	FS1 = "FS1",
	APPLE_TV = "APPLE_TV",
}

export enum HelpPages {
	Mulligan = "mulligan",
	HowToPlay = "tutorial",
	Prizes = "prizes",
	Terms = "terms",
}

export enum Handedness {
	Left = "left",
	Right = "right",
	Switch = "switch",
}

export enum ProbabilityBench {
	Sleeper = "sleeper",
}

export enum PlayerImageType {
	headshot = "headshot",
	actionShotImage = "actionShotImage",
	actionFullImage = "actionFullImage",
}

export enum SocialNetwork {
	FACEBOOK,
	TWITTER,
	MOBILE,
}

export enum ShareType {
	LEAGUE = "league-invite",
}

export enum LeaguePrivacy {
	Private = "private",
	Public = "public",
}

export enum LeagueClass {
	Featured = "featured",
	Regular = "regular",
}

export enum UserLeaderboardClass {
	Usual = "usual",
	Featured = "featured",
}
